export const listtypes = {
  radio: "LIST",
  checkmultilist: "LIST",
  customlist: "LIST",
  combobox: "BOX",
  listbox: "BOX",
  multilist: "BOX"
};
